import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FlowService from '../../services/flow-service';

// Flow 391 is the 'nhs' slug flow — stable across environments
const NHS_FLOW_ID = 391;

const CreateAccountPreFlow: React.FC = () => {
  const { search } = useLocation();

  useEffect(() => {
    // No origin rewrite here: the create-account flow (and its Auth0 callback + the mobile
    // handoff) stay on whichever origin they started on. buildCanonicalRedirectUri() uses the
    // current origin, which Auth0 already allows, so localStorage / the sl-user-flow cookie /
    // the sessionStorage redirect_url all remain visible across the round-trip.
    const params = new URLSearchParams(search);
    const redirectUrl = params.get('redirect_url') ?? '';

    // Pre-warm the Country Selector step for all users (authenticated or not).
    // 'sl-flow-progress' (FlowService) is a different localStorage key from
    // 'sl-answers' (AnswersService), so removeAnswers() inside
    // redirectUserToAppropriateFlow does not erase this pre-warm.
    //
    // The '?create_account=1' flag tells flow.container to:
    //   1. Skip the wrongOnboardingPlatform redirect in checkOnboardingPlatformAfterLogin
    //      (iOS WKWebView shares the cookie store with Safari — a stale login cookie
    //      can trigger a cross-domain redirect that iOS native intercepts, leaving the
    //      WebView alive with isLoading=true forever).
    //   2. Skip redirectUserToAppropriateFlow in getUserProgressFromAnswers when there
    //      are no answers (show Country Selector directly instead of redirecting).
    FlowService.setLocalProgress(NHS_FLOW_ID, 1, 0);
    const caQs = `?create_account=1${
      redirectUrl ? `&redirect_url=${encodeURIComponent(redirectUrl)}` : ''
    }`;
    window.location.replace(`/sleepio/nhs${caQs}`);
  }, [search]);

  return null;
};

export default CreateAccountPreFlow;
